function hexToRgbA(hex: string, opacity: number): string {
  const r: number = parseInt(hex.slice(1, 3), 16);
  const g: number = parseInt(hex.slice(3, 5), 16);
  const b: number = parseInt(hex.slice(5, 7), 16);

  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}

function componentToHex(c: number): string {
  const hex: string = Math.round(c).toString(16);
  return hex.length == 1 ? `0${hex}` : hex;
}

export function generateHeatmapColor(
  value: number,
  min: number,
  max: number,
  opacity: number
): string {
  // Calculate the normalized value between 0 and 1
  const normalizedValue: number = (value - min) / (max - min);

  // Define the heatmap colors (from cold to hot)
  const colors: { red: number; green: number; blue: number }[] = [
    { red: 0, green: 0, blue: 255 }, // Blue
    { red: 0, green: 255, blue: 255 }, // Cyan
    { red: 0, green: 255, blue: 0 }, // Green
    { red: 255, green: 255, blue: 0 }, // Yellow
    { red: 255, green: 0, blue: 0 }, // Red
  ];

  // Calculate the index of the color array
  const index: number = Math.floor(normalizedValue * (colors.length - 1));

  if (value === max) {
    const endColor = colors[colors.length - 1];
    return hexToRgbA(
      `#${componentToHex(endColor.red)}${componentToHex(
        endColor.green
      )}${componentToHex(endColor.blue)}`,
      opacity
    );
  }
  // Calculate the intermediate values between the colors
  const startColor = colors[index];
  const endColor = colors[index + 1];
  const t: number =
    (normalizedValue - index / (colors.length - 1)) * (colors.length - 1);

  // Interpolate the RGB values
  const r: number = Math.round(
    startColor.red + t * (endColor.red - startColor.red)
  );
  const g: number = Math.round(
    startColor.green + t * (endColor.green - startColor.green)
  );
  const b: number = Math.round(
    startColor.blue + t * (endColor.blue - startColor.blue)
  );

  // Convert RGB to HEX
  const hex: string = `#${componentToHex(r)}${componentToHex(
    g
  )}${componentToHex(b)}`;

  // Add opacity to the HEX color
  return hexToRgbA(hex, opacity);
}
